import { isNavigationFailure, NavigationFailureType } from 'vue-router'

/**
 * Pushes a route, swallowing ONLY the rejection vue-router raises when a
 * navigation guard redirects.
 *
 * Auth-gated routes (`beforeEnter: beforeEnterAuth(true)`) send a signed-out
 * member to login, and since vue-router 3.1 a push whose guard redirects
 * REJECTS its promise. That bounce is the intended behaviour, not a fault: the
 * global `beforeEach` has already stashed the destination, so login returns the
 * member where they were going. Every other rejection — navigation failure or
 * not — is a real fault and is rethrown as loudly as it would have been.
 *
 * `<router-link>` swallows the failure itself, so only programmatic pushes to an
 * auth-gated route need this.
 */
export default function pushIgnoringRedirect(router, location) {
    return router.push(location).catch(error => {
        if (!isNavigationFailure(error, NavigationFailureType.redirected)) throw error
    })
}
